/** Web build stub — replaces appProviders.ts via angular.json `web` fileReplacements. */
export const appProviders = [];
